import type { JSX } from 'react';

import { Chip } from '@change/ds-core-ui';

export function SectionChips({
	section,
	setSection,
	showStories,
	showPosts,
}: {
	section: string;
	setSection: React.Dispatch<React.SetStateAction<'stories' | 'posts'>>;
	showStories: boolean;
	showPosts: boolean;
}): JSX.Element {
	return (
		<div className="mb-6 flex flex-row gap-3" data-testid="share-visuals-chips" data-qa="share-visuals-chips">
			{showStories && (
				<Chip
					data-testid="stories-chip"
					data-qa="stories-chip"
					as="button"
					size="small"
					onClick={() => setSection('stories')}
					active={section === 'stories'}
					data-active={section === 'stories' ? 'true' : 'false'}
				>
					<div className="flex items-center justify-center gap-1.5">Stories</div>
				</Chip>
			)}
			{showPosts && (
				<Chip
					data-testid="posts-chip"
					data-qa="posts-chip"
					as="button"
					size="small"
					onClick={() => setSection('posts')}
					active={section === 'posts'}
					data-active={section === 'posts' ? 'true' : 'false'}
				>
					<div className="flex items-center justify-center gap-1.5">Posts</div>
				</Chip>
			)}
		</div>
	);
}
